import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useMemo } from 'react';
import { IOExtension } from 'z3k-config';
import { unpack_validation } from 'z3k-parser/validation/types';
import { Z3KSettings, Z3KSettingsEditor, } from 'console/device-settings/z3k/provider/types';
import { Z3kDragDropContainer } from '../utils/drag-drop-drawer/container';
import { Z3kSecondRoutes } from 'z3k-settings/routes/type';
import { DragDropDrawer } from '../utils/drag-drop-drawer/component';
export function IOExtensionsList() {
    const { config } = useContext(Z3KSettingsEditor);
    const { device_spec } = useContext(Z3KSettings);
    const io_extensions_count = useMemo(() => IOExtension.get.where(config, IOExtension.countMaxAmount).length, [config]);
    const hide_add_button = useMemo(() => device_spec.io.max_amount_io_extensions != null
        ? io_extensions_count >= device_spec.io.max_amount_io_extensions
        : false, [device_spec, io_extensions_count]);
    const childrenItem = (selected_item_id) => {
        return (_jsx(DragDropDrawer, { z3k_name: "io_extensions", name: "\u0423\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u044F", item_url: Z3kSecondRoutes.io_extensions, objectFilter: IOExtension.shownToUser, hideAddButton: hide_add_button, selected_item_id: selected_item_id }));
    };
    return _jsx(Z3kDragDropContainer, { childrenItem: childrenItem });
}
const fields = ['io_extensions'];
IOExtensionsList.isError = (validation_result) => fields.reduce((prev, current) => prev || !!unpack_validation(validation_result, current), false);
IOExtensionsList.isWarning = IOExtensionsList.isError;
export const isShownIoExtensionList = (is_service_view, config, spec, is_staff, is_climatic) => is_service_view && spec.io.io_extensions_supported && !is_climatic;
IOExtensionsList.isShown = isShownIoExtensionList;
